var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2500,
    height: 1244,
    viewBox: "0 0 2500 1244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1093.45 376C878.975 626.823 423.189 595.888 489.533 709.227C527.462 774.021 728.682 614.675 771.738 739.028C806.054 838.138 403.743 861.166 527.462 1042.45C689.347 1279.67 968.85 598.876 1137.93 750.542C1251.94 852.812 1041.48 948.202 1050.66 1042.45C1062.07 1159.62 1162.34 1116.13 1187.7 1116.73",
    stroke: "#A8EF12",
    strokeWidth: 76.308
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29154 -112.247C302.035 -156.041 960.885 -239.014 750.157 72.9287C539.428 384.872 23.5669 373.508 -145 292.148",
    stroke: "#A8EF12",
    strokeWidth: 76.308
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1822.11 1262.73C1822.11 1036.57 2005.34 972.552 2224.85 972.551C2529.34 972.549 2400.3 1340.39 2320.54 1433.94",
    stroke: "#A8EF12",
    strokeWidth: 76.308
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1903.45 -89.6289C1830.93 9.63856 1729.83 386.12 2033.46 363.293C2252.35 346.838 2430.27 269.268 2413.31 43.7409L2398.5 -74",
    stroke: "#A8EF12",
    strokeWidth: 76.308
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.96ec1cee93c7193f97d18039f3aa8f97.svg";
export { ForwardRef as ReactComponent };